import React from 'react'

import AddPriceOfferForm from '../../modules/PriceOffer/components/AddPriceOfferForm'
export default function AddPriceOfferPage() {
  return <AddPriceOfferForm />
}
